<template>
  <StandardResourceService title="短信服务" :tab-list="tabList" v-model="activeTab">
    <SendSmsTab v-if="activeTab === 'sendSms'"/>
    <SendRecordTab v-else-if="activeTab === 'sendRecord'"/>
    <TemplateTab v-else-if="activeTab === 'smsTemplate'"/>
    <SignatureTab v-else-if="activeTab === 'smsSignature'"/>
    <QuotaTab v-else-if="activeTab === 'smsQuota'"/>
  </StandardResourceService>
</template>

<script>
import StandardResourceService from '@/customComponents/standard/StandardResourceService.vue'
import SendSmsTab from '@/views/service_new/sms/service/SendSmsTab.vue'
import SendRecordTab from '@/views/service_new/sms/service/SendRecordTab.vue'
import TemplateTab from '@/views/service_new/sms/service/TemplateTab.vue'
import SignatureTab from '@/views/service_new/sms/service/SignatureTab.vue'
import QuotaTab from '@/views/service_new/sms/service/QuotaTab.vue'

export default {
  name: 'SmsService',
  components: {
    StandardResourceService,
    SendSmsTab,
    SendRecordTab,
    TemplateTab,
    SignatureTab,
    QuotaTab
  },
  data() {
    return {
      activeTab: 'sendSms',
      tabList: [
        { label: '发送短信', key: 'sendSms' },
        { label: '发送记录', key: 'sendRecord' },
        { label: '短信模板', key: 'smsTemplate' },
        { label: '短信签名', key: 'smsSignature' },
        { label: '短信额度', key: 'smsQuota' }
      ]
    }
  }
}
</script>

<style scoped lang="less">
</style>
